






import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class CancelButton extends Vue {
  private clickHandler () {
    this.$emit('cancel')
  }
}
